import React, {PureComponent} from 'react';
import {Avatar, Card, Typography} from '@mui/material';
import CardActionArea from "@mui/material/CardActionArea";
import {DatePrettifier} from "../../../core/prettifier/DatePrettifier";
import {ColorPicker} from "../../../core/colors/ColorPicker";
import {AttributeValuesPrettier} from "../../../core/prettifier/AttributeValuesPrettier";
import {UrlBuilder} from "../../../core/url/UrlBuilder";
import moment from "moment";
import Box from "@mui/material/Box";
import {withRouter} from "../../../hooks/withRouter";
import TimerIcon from "@mui/icons-material/Timer";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";

class WorkoutCard extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			workout: this.props.workout,
		};
	}

	redirectToWorkoutDetail = () => {
		this.props.navigate(UrlBuilder.workout.workoutDetailPage(this.state.workout.id));
	}

	getTotalSets = () => {
		let total = 0;
		this.state.workout.routines?.forEach(routine => {
			routine.exercises.forEach(exercise => {
				total += exercise.logs?.length || 0;
			});
		});
		return total;
	}

	getTotalExercises = () => {
		let total = 0;
		this.state.workout.routines?.forEach(routine => {
			total += routine.exercises.length;
		});
		return total;
	}

	render() {
		const workout = this.state.workout;
		const routineName = workout.routines[0]?.name;
		const avatarChar = routineName?.charAt(0).toUpperCase() ?? '?';
		const avatarColor = workout.routines[0]?.color ?? ColorPicker.pick(routineName ?? '');

		const workoutDurationObj = moment.duration(moment(workout.dateTimeEnded).diff(moment(workout.dateTimeStarted)));
		const workoutDuration = moment.utc(workoutDurationObj.asMilliseconds()).format('H:mm');

		const totalExercises = this.getTotalExercises();
		const totalSets = this.getTotalSets();
		const dateStarted = new Date(workout.dateTimeStarted);

		return (
			<Card variant="outlined" sx={{ borderRadius: 2.5 }}>
				<CardActionArea onClick={this.redirectToWorkoutDetail}>
					<Box sx={{ px: 2, py: 1.5 }}>
						{/* Top row: avatar, name, date */}
						<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
							<Avatar sx={{
								bgcolor: avatarColor,
								width: 36,
								height: 36,
								fontSize: 15,
								fontWeight: 600,
							}}>
								{avatarChar}
							</Avatar>
							<Box sx={{ flex: 1, minWidth: 0 }}>
								<Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.3 }} noWrap>
									{workout.name}
								</Typography>
								<Typography variant="caption" sx={{ color: 'text.secondary' }}>
									{DatePrettifier.prettifyLastTrained(dateStarted)}
								</Typography>
							</Box>
						</Box>

						{/* Exercise summary */}
						<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1 }}>
							{workout.routines.map(routine =>
								routine.exercises.map(exercise => (
									<Box
										key={routine.id + '_' + exercise.id}
										sx={{
											display: 'inline-flex',
											alignItems: 'center',
											gap: 0.5,
											bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
											borderRadius: 1,
											px: 1,
											py: 0.25,
										}}
									>
										<Typography variant="caption" sx={{ fontWeight: 500, fontSize: 12 }}>
											{exercise.name}
										</Typography>
										<Typography variant="caption" sx={{ color: 'text.disabled', fontSize: 11 }}>
											{exercise.logs?.length || 0}s
										</Typography>
									</Box>
								))
							)}
						</Box>

						{/* Bottom stats row */}
						<Box sx={{
							display: 'flex',
							alignItems: 'center',
							gap: 2,
							pt: 0.5,
							borderTop: 1,
							borderColor: 'divider',
						}}>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
								<FitnessCenterIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
								<Typography variant="caption" sx={{ color: 'text.secondary', fontSize: 12 }}>
									{totalExercises} exercise{totalExercises !== 1 ? 's' : ''} · {totalSets} set{totalSets !== 1 ? 's' : ''}
								</Typography>
							</Box>
							<Box sx={{ flex: 1 }} />
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
								<TimerIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
								<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500, fontSize: 12 }}>
									{workoutDuration}
								</Typography>
							</Box>
						</Box>
					</Box>
				</CardActionArea>
			</Card>
		);
	}
}

export default withRouter(WorkoutCard);